export default {
    datetime: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    },

    date: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    },

    dateShort: {
        month: 'long',
        day: 'numeric',
    },

    monthLong: {
        month: 'long',
    },

    monthShort: {
        month: 'short',
    },

    time: {
        hour: '2-digit',
        minute: '2-digit',
    },
};
